import React from "react";
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { OrganizationDataRecipientDto } from "../../../../common/service/server/dto/OrganizationDataRecipientDto";
import { EmptyInfo } from "../../Empty";
import { ClickThroughButton } from "../../../pages/stay-compliant/data-recipients/VendorTile";
import { DataRecipientLogo } from "../../DataRecipientLogo";

export const DataRecipientClickThroughTable: React.FC<{
  dataRecipients: OrganizationDataRecipientDto[];
  handleAddVendor?: (dr: OrganizationDataRecipientDto) => void;
  handleRemoveVendor?: (dr: OrganizationDataRecipientDto) => void;
  className?: string;
  isAdded: (dr: OrganizationDataRecipientDto) => boolean;
}> = ({ dataRecipients, handleAddVendor, handleRemoveVendor, className, isAdded }) => {
  return (
    <Table className={className}>
      <TableHead>
        <TableRow>
          <TableCell>Description</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>

      <TableBody>
        {dataRecipients.length > 0 ? (
          <>
            {dataRecipients.map((dr) => {
              return (
                <TableRow key={dr.id}>
                  <TableCell className="border-none padding-none">
                    <div className="flex flex-row p-md align-items-center">
                      <DataRecipientLogo size={32} dataRecipient={dr} logoUrl={dr.logoUrl} />
                      <div className="flex flex-col flex-grow" style={{ minWidth: 0 }}>
                        <Typography variant="body2" className="nowrap text-ellipsis">
                          {dr.name}
                        </Typography>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell className="text-right border-none padding-none">
                    <ClickThroughButton
                      added={isAdded(dr)}
                      pending={false}
                      disabled={false}
                      className={""}
                      handleAddVendor={() => handleAddVendor(dr)}
                      handleRemoveVendor={() => handleRemoveVendor(dr)}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </>
        ) : (
          <TableRow>
            <TableCell colSpan={2}>
              <EmptyInfo>No vendors added.</EmptyInfo>
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};
